export default "__VITE_ASSET__CG6Ua7Ro__"